// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Row = require("../atom/Atom_Row.bs.js");
var Atom_Logo = require("../atom/Atom_Logo.bs.js");
var Atom_Text = require("../atom/Atom_Text.bs.js");
var UseOnBlur = require("../../hook/UseOnBlur.bs.js");
var UsePortal = require("../../hook/UsePortal.bs.js");
var UseToggle = require("../../hook/UseToggle.bs.js");
var ReactDom = require("react-dom");
var Atom_Column = require("../atom/Atom_Column.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Atom_Text_Ds = require("../atom/Atom_Text_Ds.bs.js");
var Particle_zIndex = require("../particle/Particle_zIndex.bs.js");
var UseClickOutside = require("../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

var zIndexRule = Particle_zIndex.Particle_zIndex_Css.toCss({
      TAG: /* Exact */0,
      _0: /* Modal */8
    });

var containerRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("fixed"),
      CssJs.top("zero"),
      CssJs.left("zero"),
      zIndexRule
    ]);

var Organism_Modal_CSS = {
  zIndexRule: zIndexRule,
  containerRules: containerRules
};

function Molecule_Modal(Props) {
  var onClose = Props.onClose;
  var isOpen = Props.isOpen;
  var title = Props.title;
  var id = Props.id;
  var children = Props.children;
  var ref = React.useRef(null);
  var status = UseToggle.toStatus(isOpen);
  UseClickOutside.make(ref, onClose);
  UseOnBlur.make(ref, onClose);
  var modalContainerIdentifier = id + "-container";
  var modalContentIdentifier = id + "-content";
  var modalContent = React.createElement(Atom_Column.make, {
        alignItems: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
        background: Particle_Background_Ds.modalOverlay,
        children: React.createElement(Atom_Row.make, {
              background: Particle_Background_Ds.background,
              blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("XL", "L", undefined)), undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("L", "M", undefined)),
              children: null,
              identifier: modalContentIdentifier,
              innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS"),
              width: Particle_Screen_Ds.make(undefined, undefined, Css.pct(50), undefined, undefined, CssJs.pct(90)),
              wrap: /* OnOneLine */1,
              ref_: ref
            }, React.createElement(Atom_Logo.make, {
                  logo: {
                    NAME: "ArteVerticalLogo",
                    VAL: "Modal"
                  }
                }), React.createElement(Atom_Column.make, {
                  children: null
                }, React.createElement(Atom_Text.make, {
                      children: title,
                      kind: "h3",
                      style: Atom_Text_Ds.Modal.makeTitle
                    }), children !== undefined ? Caml_option.valFromOption(children) : null)),
        height: Particle_Screen_Constants.oneHundredPctHeight,
        identifier: modalContainerIdentifier,
        justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
        rules: containerRules,
        width: Particle_Screen_Constants.oneHundredPctWidth
      });
  var content = status ? null : modalContent;
  var target = UsePortal.make(id);
  if (target !== undefined) {
    return ReactDom.createPortal(content, Caml_option.valFromOption(target));
  } else {
    return null;
  }
}

var make = Molecule_Modal;

exports.Organism_Modal_CSS = Organism_Modal_CSS;
exports.make = make;
/* zIndexRule Not a pure module */
